const i18n = require('i18next');
const Moment = require('moment');
const Backbone = require('backbone');
const ProjectMemberCollection = require('common/domain/collection/project-member');

module.exports = Backbone.Model.extend({
    /**
     * Backbone.Model を extend した ProjectModel を定義する
     */
    defaults: {
        name: '',
        members: null,
        image_blob: null,
        image_url: null,
        action_state: null,
        action_type: null,
        description: '',
        notification_settings: {}
    },

    initialize: function() {
        this._members = new ProjectMemberCollection();
        this._membersWithSuspended = new ProjectMemberCollection();
        this._updateMembers();
        this.on('change:members', this._updateMembers);
    },

    _updateMembers: function() {
        this._membersWithSuspended.set(this.get('members'));
        this._members.set(this._membersWithSuspended.filter(m => !m.isSuspended()));
    },

    validation: function(){
        return {
            name: {
                required: true,
                msg: i18n.t('validation:required')
            }
        }
    },

    idParams: function() {
        return {
            project_id: this.get('id'),
            group_id: this.getGroupId()
        };
    },

    path: function() {
        return `/projects/${this.id}`;
    },

    getGroupId: function() {
        return this.get('group_id');
    },

    getActionID: function() {
        return this.get('action');
    },

    getImageURL: function() {
        return this.get('image_url');
    },

    getName: function() {
        return this.get('name');
    },

    getMembers: function(options) {
        if(options && options.withSuspended) {
            return this._membersWithSuspended;
        }
        return this._members;
    },

    isMember: function(user) {
        return user ? this.getMembers().getMemberByUser(user.id) != null : false;
    },

    getMasterBranchKey: function() {
        return this.get('master_branch');
    },

    getCreatedAt: function() {
        return this.get('created_at');
    },

    getUpdatedAt: function() {
        return this.get('updated_at');
    },

    /**
     * プロジェクト毎のデフォルトの Action 開始、終了時刻を返す。
     *
     * 時刻だけを返すと取扱が面倒なので、時刻を適切に設定した Moment オブジェクトを返す。
     * そのため日付部分に関しては実行したタイミングの日付になるので注意。
     */
    getDefaultActionTime: function() {
        return Moment({
            h: 9, m: 0, s: 0, ms: 0
        })
    },

    active: function() {
        return !(this.inactive());
    },

    inactive: function() {
        const state = this.getActionState();
        return state.type == 'final' || state.type == 'terminated';
    }
});



// WEBPACK FOOTER //
// ./common/domain/entity/project.js